<template>
    <v-card> <v-card-title>{{ playlist.name }}<v-spacer></v-spacer><span> <v-btn class="text" @click="closeDialog" text>&times;</v-btn></span></v-card-title>
      <v-img :src="playlist.image" alt="Playlist Image" height="300"/>
     
      <v-card-text>{{ playlist.user }}</v-card-text>
      <v-card-text>
        <h3>Songs</h3>
        <v-list>
          <playlist-song v-for="song in playlist.songs" :key="song.id" :song="song">
             <template #default><v-btn icon class="ml-3"> <v-icon>mdi-play</v-icon></v-btn></template></playlist-song>
        </v-list>
      </v-card-text>
      <v-card-actions><v-btn @click="closeDialog">Close</v-btn></v-card-actions>
    </v-card>

</template>

<script>
import PlaylistSong from '@/components/PlaylistSong.vue';

export default {
 props: {
    playlist: {
      type: Object,
      required: true,
    },
    
  },
   
  components: {
    PlaylistSong
  },
  
  methods:
    {
       closeDialog() {
      this.$emit('close');
    },
    }
};
</script>
<style scoped>
.text{
  font-size:20px;
  color:black;
}
</style>